import React from 'react'
import PropTypes from 'prop-types'
import { Percentage as PercentageDisplay } from '@morningtrain/react-displays'
import { useValue } from '@morningtrain/react-resources'
import * as UI from 'ui'

export default function Percentage (props) {
  const value = useValue(props.name, props.defaultValue)

  const {
    positiveColor = null,
    badColor = 'red',
  } = props

  if (props.badBelow !== null) {
    const isBad = value <= props.badBelow
    const textColor = isBad ? badColor : positiveColor
    const precedingPlus = props.showPlusIfPositive && value > 0 ? '+' : ''

    return (
      <UI.Text color={textColor}>
        {precedingPlus}<PercentageDisplay {...props} />
      </UI.Text>
    )
  }

  return <PercentageDisplay {...props} />
}

Percentage.defaultProps = {
  badBelow: null,
  showPlusIfPositive: false,
  ...PercentageDisplay.defaultProps
}

Percentage.propTypes = {
  badBelow: PropTypes.number,
  showPlusIfPositive: PropTypes.bool,
  ...PercentageDisplay.propTypes
}
